import apiClient from "./api";
const RESULTADOS_API_BASE_URL = "/resultados";
class ResultadosService {

    async getResultadosPorSolicitud(idSolicitud) {
        try {
            const response = await apiClient.get(
                `${RESULTADOS_API_BASE_URL}/solicitud/${idSolicitud}`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    agregarResultados(resultados) {
        return apiClient.post(RESULTADOS_API_BASE_URL, resultados);
    }


}
export default new ResultadosService();
